import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';

// Country coordinates (simplified; adjust as needed)
const memberCountries = [
  { name: 'Belize', coords: [17.1899, -88.4976] },
  { name: 'Benin', coords: [9.3077, 2.3158] },
  { name: 'Dominican Republic', coords: [18.7357, -70.1627] },
  { name: 'Eswatini', coords: [-26.5225, 31.4659] },
  { name: 'Fiji', coords: [-17.7134, 178.0650] },
  { name: 'Lao PDR', coords: [19.8563, 102.4955] },
  { name: 'Malawi', coords: [-13.2543, 34.3015] },
  { name: 'Mauritius', coords: [-20.3484, 57.5522] },
  { name: 'Mozambique', coords: [-18.6657, 35.5296] },
  { name: 'Sierra Leone', coords: [8.4606, -11.7799] },
  { name: 'South Africa', coords: [-30.5595, 22.9375] },
  { name: 'Sudan', coords: [12.8628, 30.2176] },
  { name: 'Tanzania', coords: [-6.3690, 34.8888] },
  { name: 'Togo', coords: [8.6195, 0.8248] },
  { name: 'Zambia', coords: [-13.1339, 27.8493] },
  { name: 'Zimbabwe', coords: [-19.0154, 29.1549] }
]satisfies { name: string; coords: [number, number] }[];

export function MemberMap() {
  return (
    <section className="py-20 bg-gradient-to-br from-leaf-green/5 to-sugar-cane/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-12">
        <h2 className="text-4xl font-bold text-forest-green mb-4">Our Global Family</h2>
        <p className="text-xl text-sugar-cane max-w-3xl mx-auto">
          Representing sugar industries across four regions and sixteen countries, from small island states to continental nations
        </p>
      </div>

      <div className="rounded-2xl overflow-hidden shadow-xl border border-leaf-green/10 mx-auto max-w-6xl h-[600px]">
        <MapContainer
          center={[0, 20]} // Approx. center of ACP countries
          zoom={2}
          scrollWheelZoom={false}
          style={{ height: '100%', width: '100%' }}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {memberCountries.map((country) => (
            <Marker position={country.coords} key={country.name}>
              <Popup>{country.name}</Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
    </section>
  );
}
